const hash = {
  start: 'end',
  end: 'start',
} as const;

type Placements = keyof typeof hash;

export default function getOppositeVariationPlacement(placement: string) {
  const replace = placement.replace(/start|end/g, (matched: string) => hash[matched as Placements]);
  if (replace === placement) {
    return placement === `right` ? `left` : `right`;
  }
  return replace;
}
